import React, { useState } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";

// Components
import OfferCombo from "./OfferCombo";

// Style
import { styleWrapper } from "./style";

const OffersList = ({ data, onChange }) => {
	const { offers, dictionaries, tripType } = data;
	const [selected, setSelected] = useState(null);
	const handleSelectCombo = (offer, bounds) => {
		const obj = { ...offer, bounds: [bounds.outbound] };
		if (tripType === "RT") {
			obj.bounds.push(bounds.inbound);
		}
		setSelected(obj);
		if (typeof onChange === "function") {
			onChange(obj);
		}
	};
	const handleUnselectCombo = () => {
		setSelected(null);
		if (typeof onChange === "function") {
			onChange(null);
		}
	};
	return (
		<div
			className={css`
				${styleWrapper}
			`}
		>
			{selected ? (
				<OfferCombo
					offer={selected}
					dictionaries={dictionaries}
					tripType={tripType}
					onClearSelected={handleUnselectCombo}
					isSelected
				/>
			) : (
				offers &&
				offers.map(offer => (
					<OfferCombo
						key={offer.id}
						offer={offer}
						dictionaries={dictionaries}
						tripType={tripType}
						onSelectCombo={bounds => handleSelectCombo(offer, bounds)}
					/>
				))
			)}
		</div>
	);
};

OffersList.propTypes = {
	data: PropTypes.shape({
		offers: PropTypes.array,
		dictionaries: PropTypes.object,
		tripType: PropTypes.oneOf(["RT", "OW"])
	})
};

OffersList.defaultProps = {
	data: {
		offers: [],
		dictionaries: null,
		tripType: "OW"
	}
};

export default OffersList;
